module.exports = __webpack_public_path__ + "static/media/TD.ff8b9be9.svg";